/**
 * 常量集合 提供给actions和reduces使用
 * @type {string}
 */

export const set_personnel_list = 'set_personnel_list';

export const update_personnel_list = 'update_personnel_list';

export const set_person_data = 'set_person_data';//初始化选中的人员数据

export const set_choose_person = 'set_choose_person';

export const delete_choose_person = 'delete_choose_person';

export const add_personnel_list = 'add_personnel_list';


